// extracted by mini-css-extract-plugin
export default {"upButton":"ButtonUp_upButton__CWStw"};